import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
import { audioContext } from '../../../webAudio/audioContext';
import { lastLoopStart } from '../lastLoopStart';

const mapStateToChordProgressProps = ({
   activeInterface: {
      userPlaying,
      referencePlaying,
      compareAnswer,
      tempo,
      referenceTempo,
   },
}) => ({
   playing: userPlaying || (compareAnswer && referencePlaying),
   stepDuration: 60 / (referencePlaying ? referenceTempo : tempo) / 4,
});

const StepOverlay = () => <div className="step-overlay" />;

const StepsOverlay = memo(({ rows }) => (
   <div>
      {new Array(rows).fill(undefined).map((val, i) => (
         <StepOverlay key={i} />
      ))}
   </div>
));

const StepSequencerCursor = connect(mapStateToChordProgressProps)(
   ({ playing, stepDuration, rows }) => {
      const [currentStep, setCurrentStep] = useState(0);

      useEffect(() => {
         let shouldAnimate = true;
         let nextFrameId;
         const animate = () => {
            const now = audioContext.currentTime;
            const loopStarted =
               now >= lastLoopStart.currentScheduledTime
                  ? lastLoopStart.currentScheduledTime
                  : lastLoopStart.previousScheduledTime;

            const newCurrentStep = Math.floor(
               (now - loopStarted) / stepDuration
            );

            if (loopStarted != null) {
               setCurrentStep(newCurrentStep);
            } else {
               setCurrentStep(0);
            }

            if (playing && shouldAnimate) {
               nextFrameId = requestAnimationFrame(animate);
            }
         };
         if (playing) {
            animate();
         } else {
            setCurrentStep(0);
         }
         return () => {
            cancelAnimationFrame(nextFrameId);
            shouldAnimate = false;
         };
      }, [playing, stepDuration]);

      return (
         <div
            className="step-sequencer-cursor"
            style={{ '--current-step': currentStep }}
         >
            <div className="active-indicator" />
            <StepsOverlay rows={rows} />
         </div>
      );
   }
);

export { StepSequencerCursor };
